<template>

    <div class="n2-center-container" id="n3-account-change-password" style="position: relative;">
        <div>
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{$t('pages.account.order.back')}}
                    </span>
                </div>
            </a>
        </div>
        <h5 class="n2-text-center">{{$t('pages.account.change_password.change_password')}}</h5>
        <div style="max-width:600px;">
            <form-input type="password" v-model="model.current_password" v-bind:label="$t('pages.account.change_password.current_password')" v-bind:errors="model_errors.current_password"></form-input>
            <form-input type="password" v-model="model.new_password" v-bind:label="$t('pages.account.change_password.new_password')" v-bind:errors="model_errors.new_password"></form-input>
            <form-input type="password" v-model="model.repeat_password" v-bind:label="$t('pages.account.change_password.repeat_password')" v-bind:errors="model_errors.repeat_password"></form-input>
            <validation-summary v-bind:errors="model_errors"></validation-summary>
            <div class="n2-margin-top">
                <button class="n2-button-1" v-on:click="changePassword">{{$t('pages.account.change_password.change_password')}}</button>
            </div>
            <div class="n2-margin-top">
                <result-summary v-bind:error="result_error"></result-summary>
            </div>
        </div>
        <h5 v-if="result=='succeeded'">{{$t('pages.account.change_password.succeeded')}}</h5>
        <app-loader v-bind:active="loading"></app-loader>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { IdentityService } from '../services'
    import AppLoader from '../components/shared/loader.vue'
    import FormInput from "../components/shared/form-input.vue"
    import ValidationSummary from '../components/shared/validation-summary.vue';
    import ResultSummary from '../components/shared/result-summary.vue';


    export default {
        components: {
            AppLoader, FormInput, ValidationSummary, ResultSummary
        },
        data: function () {
            return {
                model_errors: {},
                model: {},
                customer: {},
                loading: false,
                result: '',
                result_error: ''
            }
        },
        computed: {
            ...mapGetters('identity', [
                'user',
            ]),
        },

        created: function () {
            this.identityService = new IdentityService()

        },
        mounted: async function () {
        },
        methods: {
            validateForm: function () {
                this.model_errors = {}

                if (!this.model.current_password) {
                    this.model_errors['current_password'] = [this.$t('pages.account.change_password.error_current_password')]
                }
                var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
                if (!strongRegex.test(this.model.new_password)) {
                    this.model_errors['new_password'] = [this.$t('pages.account.change_password.error_new_password')]
                }
                if (this.model.new_password != this.model.repeat_password) {
                    this.model_errors['repeat_password'] = [this.$t('pages.account.change_password.error_repeat_password')]
                }
                //////////////////
                if (Object.keys(this.model_errors).length > 0) {
                    return false
                }
                else {
                    return true
                }
            },
            changePassword: async function () {
                this.result_error = '';

                if (!this.validateForm()) {
                    return
                }
                try {
                    this.loading=true;
                    await this.identityService.changePassword(this.model)
                    this.result = 'succeeded'
                    this.model = {}
                }
                catch (err) {
                    if ( err.errors && err.errors.current_password) {
                        this.$set(this.model_errors, 'current_password', [this.$t('pages.account.change_password.error_worng_current_password')])
                    }
                    else {
                        this.result_error = this.$t('pages.account.change_password.failed')
                    }
                }
                finally
                {
                    this.loading=false;
                }
            }
        }
    }
</script>
